import Axios from 'axios';
import ApiUtils from './api-utils';
import { pickBy } from 'lodash';

export default {
  getArticlesCommandables: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/articles', { params: { commandablesByTiers: numTiers } })),
  getSupplementations: (codeTypeArticle, numArticle, numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/articles/' + codeTypeArticle + '/' + numArticle + '/supplementations?numTiers=' + numTiers)),
  getMineraux: (codeTypeArticle, numArticle, numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/articles/' + codeTypeArticle + '/' + numArticle + '/mineraux?numTiers=' + numTiers)),
  getContraintesLivraison: (codeTypeArticle, numArticle, numTiers, numAdr) => ApiUtils.responseParser(Axios.get('/web/v1/articles/' + codeTypeArticle + '/' + numArticle + '/contraintes-livraison?numTiers=' + numTiers + '&numAdr=' + numAdr)),

  getArticlesModifiables: (numTiers, search, commandable) => {
    const params = pickBy({ numTiers, search, commandable }, i => i !== undefined && i !== null);
    return ApiUtils.responseParser(Axios.get('/web/v1/articles/modifiables', { params }));
  },
  setArticleCommandable: (numArticle, numTiers, artCommandable) => ApiUtils.responseParser(Axios.patch(`/web/v1/articles/${numArticle}?numTiers=${numTiers}`, { artCommandable })),
  validerAdresseLivraison: (numArticle, numTiers, numAdresse) => ApiUtils.responseParser(Axios.get(`/web/v1/articles/M/${numArticle}/validationAdresseLivraison/${numTiers}/${numAdresse}`)),
  diag (numArticle, numTiers) {
    return ApiUtils.responseParser(Axios.get(`/web/v1/articles/${numArticle}/diagnostic?numTiers=${numTiers}`));
  }
};
